const menuParent = $('.list-float-menu');
const mobileBg = $('.list-float-menu-bg');
const listSection = $('.list-section-parent');
const list = $('.list-parent');
const mobileMenuMini = menuParent.find('.float-menu-mobile-mini');
const mobileMenuFull = menuParent.find('.float-menu-mobile-full');

const anchors = $('.list-anchor-link');
let activeAnchor = undefined;

let isMobileView = !isDesktop();
let menuTL;
let floatMenuLenisInstance;
let menuLenisInstance;
let scrollTriggers = [];
let isInWindow = false;

const shouldBlockTriggerSync = () => typeof blockTriggers !== 'undefined' && blockTriggers;

const getAnchorTargetTitle = (anchor) => {
  const href = anchor.attr('href');
  const anchorToElement = $(href);
  return anchorToElement.find('.list-point-title').text();
};

const toggleMenuAnimation = () => {
  const tl = gsap.timeline({
    paused: true,
    onComplete: () => lenis.stop?.(),
    onReverseComplete: () => lenis.start?.(),
  });

  tl.add(
    gsap.fromTo(
      mobileMenuMini,
      { opacity: 1, backdropFilter: 'blur(100px)' },
      { opacity: 0, backdropFilter: 'blur(0px)', duration: 0.33, ease: 'opacityInEasing' }
    ),
    0
  );

  tl.add(gsap.fromTo(mobileMenuFull, { y: '100%' }, { y: 0, duration: 0.83, ease: 'pageInEasing' }), 0.33);

  tl.add(
    gsap.fromTo(
      mobileBg,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 0.83,
        ease: 'pageInEasing',
        onComplete: () => gsap.set(mobileBg, { pointerEvents: 'all' }),
        onReverseComplete: () => gsap.set(mobileBg, { pointerEvents: 'none' }),
      }
    ),
    0.33
  );

  return tl;
};

const toggleAnchor = (anchor, isByTrigger) => {
  if (activeAnchor !== undefined) anchors.eq(activeAnchor).removeClass('active');
  anchor.addClass('active');

  if (isByTrigger && floatMenuLenisInstance) {
    floatMenuLenisInstance.scrollTo(anchor.get(0), { offset: -vwToPx(2.5) });
  }

  activeAnchor = anchors.index(anchor);
};

$('.list-point-main br').each(function () {
  $('<div style="height: 0.313vw;"></div>').insertAfter($(this));
});

const destroyAll = () => {
  if (menuLenisInstance) menuLenisInstance.destroy();
  if (floatMenuLenisInstance) floatMenuLenisInstance.destroy();
  if (menuTL) menuTL.kill();
  scrollTriggers.forEach((st) => st.kill());
  scrollTriggers = [];
};

const initDesktopMenu = () => {
  destroyAll();

  floatMenuLenisInstance = new Lenis({
    wrapper: menuParent.get(0),
    autoRaf: true,
  });

  anchors.each(function () {
    const href = $(this).attr('href');
    const anchorToElement = $(href);
    const st = ScrollTrigger.create({
      trigger: anchorToElement,
      start: 'top top+=20%',
      end: 'bottom top+=20%',
      onEnter: () => {
        if (!shouldBlockTriggerSync()) {
          toggleAnchor($(this), true);
        }
      },
      onEnterBack: () => {
        if (!shouldBlockTriggerSync()) {
          toggleAnchor($(this), true);
        }
      },
    });
    scrollTriggers.push(st);
  });

  toggleAnchor(anchors.eq(0));
};

const initMobileMenu = () => {
  destroyAll();

  menuTL = toggleMenuAnimation();

  const downloadBtn = listSection.find('.button-placer');
  const mobileMenuLinksParent = menuParent.find('.float-menu-mobile-list');
  const mobileMenuInnerLinksAll = mobileMenuFull.find('.warranty-list-type-parent-mobile');

  menuLenisInstance = new Lenis({
    wrapper: mobileMenuLinksParent.get(0),
    autoRaf: true,
  });

  ScrollTrigger.create({
    trigger: list,
    start: 'top top',
    end: 'bottom bottom',
    onEnter: () => (isInWindow = true),
    onEnterBack: () => (isInWindow = true),
    onLeave: () => (isInWindow = false),
    onLeaveBack: () => (isInWindow = false),
  });

  if (isTablet()) {
    const menuBtn = $('.button-placer');
    mobileMenuFull.append(menuBtn);
  } else {
    listSection.prepend(downloadBtn);
  }

  const toggleMenuFull = (open) => {
    if (open) menuTL.play();
    else menuTL.reverse();
  };

  mobileMenuMini.off('click').on('click', function (e) {
    if (isInWindow) {
      e.stopPropagation();
      toggleMenuFull(true);
    }
  });

  mobileBg.off('click').on('click', function (e) {
    e.stopPropagation();
    toggleMenuFull(false);
  });

  mobileMenuFull.off('click').on('click', function (e) {
    e.stopPropagation();
  });

  mobileMenuInnerLinksAll.off('click').on('click', function () {
    const clickedLink = $(this);
    const href = clickedLink.attr('href');
    const matchingDesktopAnchor = anchors.filter(`[href="${href}"]`).first();

    if (matchingDesktopAnchor.length) {
      toggleAnchor(matchingDesktopAnchor, false);
      $('.float-menu-mobile-mini-label').text(getAnchorTargetTitle(matchingDesktopAnchor));
    }

    lenis.start?.();
    toggleMenuFull(false);
  });

  anchors.each(function () {
    const href = $(this).attr('href');
    const anchorToElement = $(href);
    const elementTitle = getAnchorTargetTitle($(this));

    const st = ScrollTrigger.create({
      trigger: anchorToElement,
      start: 'top bottom-=20%',
      end: 'bottom bottom-=20%',
      onEnter: () => {
        if (!shouldBlockTriggerSync()) {
          $('.float-menu-mobile-mini-label').text(elementTitle);
        }
      },
      onEnterBack: () => {
        if (!shouldBlockTriggerSync()) {
          $('.float-menu-mobile-mini-label').text(elementTitle);
        }
      },
    });
    scrollTriggers.push(st);
  });

  $('.float-menu-mobile-mini-label').text(list.find('.list-point-title').first().text());
};

const handleResize = () => {
  const nowMobile = !isDesktop();
  if (nowMobile !== isMobileView) {
    isMobileView = nowMobile;
    if (isMobileView) initMobileMenu();
    else initDesktopMenu();
  }
};

$(window).on('deviceChange', handleResize);

if (isMobileView) initMobileMenu();
else initDesktopMenu();

anchors.off('click').on('click', function () {
  toggleAnchor($(this), false);
});
